@use '@design/design-tokens/border-radius/border-radius' as *;

.root {
  width: 100%;
  height: 52px;
  @include border-radius-r2;
  border: 1px solid var(--border-soft);
  background-color: var(--background-soft);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 4px;
  gap: 4px;
}
